import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsOfService: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      className="bg-gradient-to-br from-app-page-from to-app-page-to"
      style={{ width: '100%', height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}
    >
      <div className="app-breadcrumb-bar">
        <div className="app-breadcrumb-row">
          <button onClick={() => navigate('/')} className="app-breadcrumb-link">Home</button>
          <span className="app-breadcrumb-sep">›</span>
          <span className="app-breadcrumb-current">Terms of Service</span>
        </div>
      </div>

      <div className="flex-1 overflow-auto p-3 pb-4 md:p-4 md:pb-4 lg:p-6 lg:pb-6">
        <div className="bg-white rounded-lg shadow-md overflow-hidden">

          <div className="p-4 md:p-6 bg-gradient-to-r from-blue-500 to-blue-600 text-white">
            <div className="flex items-start gap-3">
              <div className="w-9 h-9 rounded-lg bg-white/20 flex items-center justify-center text-lg shrink-0">📋</div>
              <div className="min-w-0 text-left">
                <h1 className="text-xl md:text-2xl font-bold leading-snug">Terms of Service</h1>
                <p className="text-app-header-muted text-xs md:text-sm mt-0.5">Last updated: April 2026</p>
              </div>
            </div>
          </div>

          <div className="p-6 md:p-8 text-left">

          <section className="mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">1. Acceptance of Terms</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              By accessing or using ExamMasters ("the platform") at <strong>exammasters.com.au</strong>, you agree to be bound by these Terms of Service. If you do not agree, please do not use the platform.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">2. Use of the Platform</h2>
            <ul className="list-disc list-inside text-sm text-gray-600 leading-relaxed space-y-1">
              <li>You must be at least 13 years old to create an account.</li>
              <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
              <li>You agree not to share, resell, or redistribute any course content.</li>
              <li>You agree not to use the platform for any unlawful or abusive purpose.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">3. Subscriptions and Payments</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Some features require a paid subscription. Payments are processed securely via Stripe. Subscription fees are billed in advance and are non-refundable except as required by applicable law. We reserve the right to change pricing with reasonable notice.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">4. Intellectual Property</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              All content on the platform — including questions, explanations, diagrams, and course materials — is the intellectual property of ExamMasters. You may not copy, reproduce, or distribute this content without our prior written consent.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">5. Disclaimer of Warranties</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              The platform is provided "as is" without warranties of any kind. We do not guarantee that the platform will be error-free, uninterrupted, or that results obtained from using it will be accurate or reliable.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">6. Limitation of Liability</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              To the fullest extent permitted by law, ExamMasters shall not be liable for any indirect, incidental, or consequential damages arising from your use of the platform.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">7. Termination</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              We reserve the right to suspend or terminate your account at our discretion if you violate these terms. You may also close your account at any time by contacting support.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">8. Changes to Terms</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              We may update these Terms from time to time. Continued use of the platform after changes constitutes your acceptance of the revised Terms.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-2">9. Contact</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              For questions about these Terms, contact us at{' '}
              <a href="mailto:support@exammasters.com.au" className="text-indigo-600 hover:underline">
                support@exammasters.com.au
              </a>.
            </p>
          </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
